import { useMemo } from 'react'

import { CancelButtonRenderer } from './components/CancelButtonRenderer'
import { DurationRenderer } from './components/DurationRenderer'
import { JobActionsRenderer } from './components/JobActionsRenderer'
import { JobStatusRenderer } from './components/JobStatusRenderer'
import { OutcomeCountsRenderer } from './components/OutcomeCountsRenderer'
import { PriorityNameRenderer } from './components/PriorityNameRenderer'
import { ProgressRenderer } from './components/ProgressRenderer'
import { formatters } from '@utils/intl/dateTimeFormatters'

export const useColumnDefs = (onCancel: (jobId: string) => void, onViewDetails: (jobId: string) => void) => {
  return useMemo(
    () => [
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: JobStatusRenderer,
        minWidth: 120,
        maxWidth: 120,
      },
      {
        headerName: 'Type',
        field: 'job_type',
        valueFormatter: ({ value }: { value: string }) => value?.replace('_', ' ').toUpperCase() || '',
        minWidth: 150,
        maxWidth: 150,
      },
      {
        headerName: 'Priority',
        field: 'priority_name',
        cellRenderer: PriorityNameRenderer,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        headerName: '#',
        field: 'priority',
        type: 'rightAligned',
        minWidth: 60,
        maxWidth: 60,
        hide: true,
      },
      {
        headerName: 'Created By',
        field: 'created_by',
        minWidth: 150,
        hide: true,
      },
      {
        headerName: 'Created At',
        field: 'created_at',
        valueFormatter: ({ value }: { value: string }) => (value ? formatters.DATE_TIME(value) : ''),
        minWidth: 180,
        hide: true,
      },
      {
        headerName: 'Updated At',
        field: 'updated_at',
        valueFormatter: ({ value }: { value: string }) => (value ? formatters.DATE_TIME(value) : ''),
        minWidth: 180,
        hide: true,
      },
      {
        headerName: 'Orders',
        field: 'successful_updates',
        cellRenderer: OutcomeCountsRenderer,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        headerName: 'Duration',
        field: 'current_duration_seconds',
        cellRenderer: DurationRenderer,
        minWidth: 140,
        maxWidth: 140,
      },
      {
        headerName: 'Progress',
        field: 'progress',
        cellRenderer: ProgressRenderer,
        minWidth: 200,
        sortable: true,
      },
      {
        headerName: 'Actions',
        cellRenderer: (params: any) => <CancelButtonRenderer data={params.data} onCancel={onCancel} />,
        pinned: 'right',
        minWidth: 120,
        maxWidth: 120,
        filter: false,
        sortable: false,
      },
    ],
    [onCancel, onViewDetails]
  )
}
